import classnames from 'classnames';
import { API } from 'common';
import BottomSheet, { useBottomSheetRef } from 'components/BottomSheet';
import MyDatePicker from 'components/DatePicker';
import MyDateRangePicker from 'components/DatePicker/Range';
import Loader from 'components/Loader';
import Page from 'components/Page';
import moment from 'moment';
import React, { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { formatCurrency } from 'utils/formatCurrency';
import { formatPhone } from 'utils/formatPhone';

const sourceOpts = [
  { label: 'All Source', value: 'all_source' },
  { label: 'Ticket', value: 'ticket' },
  { label: 'Appointment', value: 'appointment' },
  { label: 'Marketing', value: 'marketing' },
  { label: 'Review', value: 'review' },
]

const Coupon = () => {
  const [sourceFilter, setSourceFilter] = React.useState(sourceOpts[0].value);
  const [loading, setLoading] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState('DAY');
  // report/shop-day payload shape isn't modeled (view never reads dataList back)
  const [dataList, setDataList] = React.useState<any[]>([]);

  const toggle = (tab: string) => {
    let range_param = '';
    const now = new Date();
    switch (tab) {
      case 'WEEK': {
        const dateMoment = moment(now);
        const start_date = dateMoment.startOf('week').format('MM-DD-YYYY');
        const end_date = dateMoment.endOf('week').format('MM-DD-YYYY');
        range_param = `startDate=${start_date}&endDate=${end_date}`;
        break;
      }
      case 'MONTH': {
        const dateMoment = moment(now);
        const start_date = dateMoment.startOf('month').format('MM-DD-YYYY');
        const end_date = dateMoment.endOf('month').format('MM-DD-YYYY');
        range_param = `startDate=${start_date}&endDate=${end_date}`;
        break;
      }
      case 'DAY':
      default: {
        const dateMoment = moment(now).format('MM-DD-YYYY');
        range_param = `startDate=${dateMoment}&endDate=${dateMoment}`;
        break;
      }
    }
    fetchData(range_param);
    if (activeTab !== tab) setActiveTab(tab);
  };

  const fetchData = async (range_param: string) => {
    setLoading(true);
    try {
      let response = await API.get(`report/shop-day?type=FROM-TO&${range_param}`);
      if (response.status == 200) {
        let { payload } = response.data;
        if (payload) {
          setDataList(payload);
        }
      }
    } catch (error) {
      console.error('get_summary_report_data', error);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => toggle('DAY'), []);

  const Dashboard = () => {
    return (
      <div className='marketing_report_coupon_kit_dashboard'>
        <div className="profit_box">
          <div className="profit_label">Coupons Profit</div>
          <div className="profit_value">{formatCurrency(600)}</div>
        </div>
        <div className="detail_boxes">
          <div className="detail_box_item">
            <div className="detail_box_item_label">Total Bill</div>
            <div className="detail_box_item_value">{formatCurrency(10000)}</div>
            <div className="detail_box_item_icon"><IconBill /></div>
          </div>
          <div className="detail_box_item">
            <div className="detail_box_item_label">Coupon Used</div>
            <div className="detail_box_item_value">{500}</div>
            <div className="detail_box_item_icon"><IconUsed /></div>
          </div>
          <div className="detail_box_item">
            <div className="detail_box_item_label">Discount</div>
            <div className="detail_box_item_value">{formatCurrency(1000)}</div>
            <div className="detail_box_item_icon"><IconDiscount /></div>
          </div>
        </div>
      </div>
    )
  };

  const RedeemHistory = () => {
    return (
      <div className="marketing_report_coupon_kit_container coupon_section marketing_report_coupon_kit_redeem_history">
        <div className="redeem_history_header">
          <span className="title">Redeem History</span>
          <ButtonSourceDropdown value={sourceFilter} onChange={setSourceFilter} options={sourceOpts} />
        </div>
        <div className="redeem_history_items">
          {
            redeemHistory.map(o => (
              <div key={o.id} className="redeem_history_item">
                <div className="customer_info">
                  <span className="customer_info_name">{o.customerName}</span>
                  <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                    <IconCalling />
                    <span className="customer_info_phone">{formatPhone(o.phone)}</span>
                  </div>
                </div>

                <div className="ticket_info">
                  <span className="ticket_info_id">#{o.id}</span>
                  <span className="ticket_info_create_date">{o.createDate}</span>
                </div>

                <div className="coupon_info">
                  <span className="coupon_info_message">{o.content}</span>
                  <div className="d-flex align-items-center">
                    <span className="coupon_info_amount">{formatCurrency(o.amount)}</span>
                    <span className="coupon_info_price">{formatCurrency(-o.discount)}</span>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    )
  };

  return (
    <>
      {loading && <Loader />}
      <Page title={'Coupon'} className={'marketing_report_coupon_kit'} border>
        <Nav tabs className="overview-custom-nav custom-nav-light">
          <NavItem className="tab-item">
            <NavLink
              className={classnames({ active: activeTab === 'DAY' })}
              onClick={() => toggle('DAY')}>
              TODAY
            </NavLink>
          </NavItem>
          <NavItem className="tab-item">
            <NavLink
              className={classnames({ active: activeTab === 'WEEK' })}
              onClick={() => toggle('WEEK')}>
              WEEKLY
            </NavLink>
          </NavItem>
          <NavItem className="tab-item">
            <NavLink
              className={classnames({ active: activeTab === 'MONTH' })}
              onClick={() => toggle('MONTH')}>
              MONTHLY
            </NavLink>
          </NavItem>
          <NavItem className="tab-item">
            <NavLink
              className={classnames({ active: activeTab === 'RANGE' })}
              onClick={() => toggle('RANGE')}>
              RANGE
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab} style={{ color: "#000000", backgroundColor: '#F3F3F3', minHeight: '100vh' }}>
          <TabPane tabId="DAY">
            <div className="marketing_report_coupon_kit_container coupon_section">
              <MyDatePicker daily unsetMaxDate stringData={fetchData} />
              <Dashboard />
            </div>
            <RedeemHistory />
          </TabPane>
          <TabPane tabId="WEEK">
            <div className="marketing_report_coupon_kit_container coupon_section">
              <MyDatePicker weekly unsetMaxDate stringData={fetchData} />
              <Dashboard />
            </div>
          </TabPane>
          <TabPane tabId="MONTH">
            <div className="marketing_report_coupon_kit_container coupon_section">
              <MyDatePicker monthly unsetMaxDate stringData={fetchData} />
              <Dashboard />
            </div>
          </TabPane>
          <TabPane tabId="RANGE">
            <div className="marketing_report_coupon_kit_container coupon_section">
              <MyDateRangePicker stringData={fetchData} />
              <Dashboard />
            </div>
          </TabPane>
        </TabContent>
      </Page>
    </>
  )
}

export default Coupon;

const redeemHistory = [
  {
    customerName: 'Jenny Wilson', phone: '3002565874',
    id: 15755,
    createDate: '10-22-2023 10:30AM',
    content: 'Coupon Sale Off 10%',
    amount: 100,
    discount: 10,
  },
];


interface SourceOption {
  label: string;
  value: string;
}

interface ButtonSourceDropdownProps {
  value?: string;
  options?: SourceOption[];
  onChange: (value: string) => void;
}

const ButtonSourceDropdown = ({ value = '', options = [], onChange }: ButtonSourceDropdownProps) => {
  const bsRef = useBottomSheetRef();
  const label = options.find(o => o.value === value)?.label || 'Label';

  const onChooseOption = (op: SourceOption) => () => {
    onChange(op.value);
    bsRef.current.close();
  };
  return (
    <div className="filter_option_kit drop_down_tag_kit dropdown_filter">
      <button className="d-flex align-items-center" onClick={() => bsRef.current.open()}>
        <span>{label}</span>
        <IconArrowDown />
      </button>
      <BottomSheet
        ref={bsRef}
        autoHeight
        className='filter_option_kit_container_bs'
        title={"Source"}
      >
        <div className='filter_option_kit_container_wrap'>
          <div className='filter_option_kit_items'>
            {options.map(o => (
              <button key={o.value} className={`filter_option_kit_item ${value === o.value ? 'active' : ''}`} onClick={onChooseOption(o)}>
                <span>{o.label}</span>
                {value === o.value && <IconChecked />}
              </button>
            ))}
          </div>
        </div>
      </BottomSheet>
    </div>
  )
}

const IconBill = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M19.875 20.5917C19.2334 20.0473 18.2666 20.0473 17.625 20.5917C16.9834 21.1361 16.0166 21.1361 15.375 20.5917C14.7334 20.0473 13.7666 20.0473 13.125 20.5917C12.4834 21.1361 11.5166 21.1361 10.875 20.5917C10.2334 20.0473 9.26659 20.0473 8.625 20.5917C7.98341 21.1361 7.01659 21.1361 6.375 20.5917C5.73341 20.0473 4.76659 20.0473 4.125 20.5917C3.68909 20.9616 3 20.6662 3 20.1094V3.89059C3 3.33383 3.68909 3.03842 4.125 3.40832C4.76659 3.95274 5.73341 3.95274 6.375 3.40832C7.01659 2.86389 7.98341 2.86389 8.625 3.40832C9.26659 3.95274 10.2334 3.95274 10.875 3.40832C11.5166 2.86389 12.4834 2.86389 13.125 3.40832C13.7666 3.95274 14.7334 3.95274 15.375 3.40832C16.0166 2.86389 16.9834 2.86389 17.625 3.40832C18.2666 3.95274 19.2334 3.95274 19.875 3.40832C20.3109 3.03842 21 3.33383 21 3.89059V20.1094C21 20.6662 20.3109 20.9616 19.875 20.5917ZM6.75 12C6.75 11.5858 7.08579 11.25 7.5 11.25H16.5C16.9142 11.25 17.25 11.5858 17.25 12C17.25 12.4142 16.9142 12.75 16.5 12.75H7.5C7.08579 12.75 6.75 12.4142 6.75 12ZM7.5 7.75C7.08579 7.75 6.75 8.08579 6.75 8.5C6.75 8.91421 7.08579 9.25 7.5 9.25H16.5C16.9142 9.25 17.25 8.91421 17.25 8.5C17.25 8.08579 16.9142 7.75 16.5 7.75H7.5ZM6.75 15.5C6.75 15.0858 7.08579 14.75 7.5 14.75H16.5C16.9142 14.75 17.25 15.0858 17.25 15.5C17.25 15.9142 16.9142 16.25 16.5 16.25H7.5C7.08579 16.25 6.75 15.9142 6.75 15.5Z" fill="#0C719C" />
  </svg>
);

const IconUsed = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="coupon-codes-svgrepo-com 1">
      <path id="Vector" d="M23.0767 9.04601V5.72294C23.0773 5.5773 23.0491 5.43299 22.9936 5.29832C22.9382 5.16365 22.8566 5.0413 22.7536 4.93832C22.6507 4.83534 22.5283 4.75377 22.3936 4.69832C22.259 4.64287 22.1146 4.61463 21.969 4.61524H7.56901V5.35371H6.83055V4.61524H2.03055C1.88492 4.61463 1.7406 4.64287 1.60594 4.69832C1.47127 4.75377 1.34892 4.83534 1.24594 4.93832C1.14295 5.0413 1.06139 5.16365 1.00594 5.29832C0.950485 5.43299 0.922251 5.5773 0.922861 5.72294V9.04601C1.70627 9.04601 2.45759 9.35722 3.01155 9.91117C3.5655 10.4651 3.87671 11.2165 3.87671 11.9999C3.87671 12.7833 3.5655 13.5346 3.01155 14.0885C2.45759 14.6425 1.70627 14.9537 0.922861 14.9537V18.2768C0.922251 18.4224 0.950485 18.5667 1.00594 18.7014C1.06139 18.8361 1.14295 18.9584 1.24594 19.0614C1.34892 19.1644 1.47127 19.246 1.60594 19.3014C1.7406 19.3569 1.88492 19.3851 2.03055 19.3845H6.83055V18.646H7.56901V19.3845H21.969C22.1146 19.3851 22.259 19.3569 22.3936 19.3014C22.5283 19.246 22.6507 19.1644 22.7536 19.0614C22.8566 18.9584 22.9382 18.8361 22.9936 18.7014C23.0491 18.5667 23.0773 18.4224 23.0767 18.2768V14.9537C22.2933 14.9537 21.542 14.6425 20.988 14.0885C20.4341 13.5346 20.1229 12.7833 20.1229 11.9999C20.1229 11.2165 20.4341 10.4651 20.988 9.91117C21.542 9.35722 22.2933 9.04601 23.0767 9.04601ZM7.56901 17.1691H6.83055V15.6922H7.56901V17.1691ZM7.56901 14.2152H6.83055V12.7383H7.56901V14.2152ZM7.56901 11.2614H6.83055V9.78448H7.56901V11.2614ZM7.56901 8.30755H6.83055V6.83063H7.56901V8.30755ZM12.369 13.3383L11.6813 13.846L10.9336 12.8306L10.1536 13.846L9.47055 13.3383L10.2229 12.2629L9.07825 11.9122L9.33209 11.1091L10.4582 11.4737V10.1537H11.3813V11.4552L12.5075 11.0906L12.7613 11.8937L11.6121 12.2445L12.369 13.3383ZM18.2167 13.3383L17.5382 13.846L16.7906 12.8306L16.0059 13.846L15.3182 13.3383L16.0706 12.2629L14.9213 11.9122L15.1752 11.1091L16.3013 11.4737V10.1537H17.2244V11.4552L18.3506 11.0906L18.6044 11.8937L17.4598 12.2445L18.2167 13.3383Z" fill="#0C719C" />
    </g>
  </svg>
);

const IconDiscount = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="discount-shape-svgrepo-com 1">
      <path id="Vector" d="M21.5289 10.8689L20.0089 9.34891C19.7489 9.08891 19.5389 8.57891 19.5389 8.21891V6.05891C19.5389 5.17891 18.8189 4.45891 17.9389 4.45891H15.7889C15.4289 4.45891 14.9189 4.24891 14.6589 3.98891L13.1389 2.46891C12.5189 1.84891 11.4989 1.84891 10.8789 2.46891L9.33891 3.98891C9.08891 4.24891 8.57891 4.45891 8.20891 4.45891H6.05891C5.17891 4.45891 4.45891 5.17891 4.45891 6.05891V8.20891C4.45891 8.56891 4.24891 9.07891 3.98891 9.33891L2.46891 10.8589C1.84891 11.4789 1.84891 12.4989 2.46891 13.1189L3.98891 14.6389C4.24891 14.8989 4.45891 15.4089 4.45891 15.7689V17.9189C4.45891 18.7989 5.17891 19.5189 6.05891 19.5189H8.20891C8.56891 19.5189 9.07891 19.7289 9.33891 19.9889L10.8589 21.5089C11.4789 22.1289 12.4989 22.1289 13.1189 21.5089L14.6389 19.9889C14.8989 19.7289 15.4089 19.5189 15.7689 19.5189H17.9189C18.7989 19.5189 19.5189 18.7989 19.5189 17.9189V15.7689C19.5189 15.4089 19.7289 14.8989 19.9889 14.6389L21.5089 13.1189C22.1589 12.5089 22.1589 11.4889 21.5289 10.8689ZM7.99891 8.99891C7.99891 8.44891 8.44891 7.99891 8.99891 7.99891C9.54891 7.99891 9.99891 8.44891 9.99891 8.99891C9.99891 9.54891 9.55891 9.99891 8.99891 9.99891C8.44891 9.99891 7.99891 9.54891 7.99891 8.99891ZM9.5289 15.5289C9.3789 15.6789 9.18891 15.7489 8.99891 15.7489C8.80891 15.7489 8.61891 15.6789 8.46891 15.5289C8.17891 15.2389 8.17891 14.7589 8.46891 14.4689L14.4689 8.46891C14.7589 8.17891 15.2389 8.17891 15.5289 8.46891C15.8189 8.75891 15.8189 9.23891 15.5289 9.52891L9.5289 15.5289ZM14.9989 15.9989C14.4389 15.9989 13.9889 15.5489 13.9889 14.9989C13.9889 14.4489 14.4389 13.9989 14.9889 13.9989C15.5389 13.9989 15.9889 14.4489 15.9889 14.9989C15.9889 15.5489 15.5489 15.9989 14.9989 15.9989Z" fill="#0C719C" />
    </g>
  </svg>
);

const IconArrowDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M3.52876 6.02892C3.78911 5.76857 4.21122 5.76857 4.47157 6.02892L8.00016 9.55752L11.5288 6.02892C11.7891 5.76857 12.2112 5.76857 12.4716 6.02892C12.7319 6.28927 12.7319 6.71138 12.4716 6.97173L8.47157 10.9717C8.21122 11.2321 7.78911 11.2321 7.52876 10.9717L3.52876 6.97173C3.26841 6.71138 3.26841 6.28927 3.52876 6.02892Z" fill="#0C719C" />
  </svg>
);

const IconChecked = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M9.72692 18C9.40676 18 9.10261 17.8661 8.8785 17.6317L4.34817 12.8936C3.88394 12.4081 3.88394 11.6045 4.34817 11.1189C4.8124 10.6334 5.58078 10.6334 6.04501 11.1189L9.72692 14.9697L17.955 6.36414C18.4192 5.87862 19.1876 5.87862 19.6518 6.36414C20.1161 6.84967 20.1161 7.6533 19.6518 8.13882L10.5753 17.6317C10.3512 17.8661 10.0471 18 9.72692 18Z" fill="#0C719C" />
  </svg>
);
const IconCalling = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path d="M13.5177 6.76643C13.6742 6.65423 13.7658 6.45768 13.7477 6.26537C13.6811 5.67121 13.5222 5.08739 13.2762 4.5423C12.7017 3.26299 11.6301 2.21498 10.337 1.67042C9.83732 1.45212 9.3034 1.32374 8.76418 1.25L8.63096 1.25C8.39718 1.27546 8.18727 1.45557 8.14004 1.68819C8.08511 1.90915 8.18462 2.15504 8.37409 2.27971C8.52747 2.38925 8.72437 2.38315 8.90243 2.41631C9.76434 2.56777 10.5817 2.97254 11.218 3.5736C11.986 4.28607 12.4889 5.27651 12.6122 6.31656C12.6295 6.50967 12.7266 6.70171 12.9004 6.79773C13.088 6.91099 13.3431 6.89906 13.5177 6.76643Z" fill="#686868" />
    <path d="M12.8886 12.9634C13.0439 12.7108 13.1224 12.4153 13.1244 12.1195C13.1252 11.5851 13.1252 11.0505 13.1244 10.5158C13.1229 10.2559 13.0693 9.9949 12.9513 9.76243C12.7258 9.29697 12.2635 8.96046 11.7545 8.87932C11.3206 8.81599 10.8895 8.72468 10.4757 8.57716C10.3252 8.52654 10.1754 8.46906 10.0177 8.44413C9.69657 8.38894 9.35942 8.43472 9.06441 8.57334C8.72066 8.72315 8.48608 9.0271 8.21849 9.27687C7.21897 8.64761 6.36874 7.78689 5.73226 6.79163C5.94425 6.56983 6.18747 6.3717 6.34817 6.10641C6.60764 5.69818 6.6579 5.17015 6.49771 4.71512C6.35858 4.31757 6.23545 3.91239 6.17224 3.495C6.13796 3.26431 6.10293 3.02827 5.99934 2.81666C5.75308 2.26904 5.18135 1.89286 4.58271 1.87658C4.01529 1.87378 3.44762 1.87658 2.8802 1.87505C2.43134 1.87124 1.98503 2.06632 1.6819 2.398C1.43487 2.66125 1.28382 3.01022 1.25564 3.36987C1.23863 3.53214 1.26351 3.69467 1.28534 3.85516C1.56613 6.17483 2.60931 8.38309 4.17548 10.1088C5.29306 11.3394 6.69548 12.298 8.22205 12.9456C9.05934 13.2872 9.9342 13.5377 10.8289 13.672C11.0987 13.7028 11.3681 13.7717 11.6415 13.7432C12.1495 13.7018 12.6278 13.4022 12.8886 12.9634ZM12.0353 12.2144C11.9977 12.4634 11.7644 12.6651 11.5131 12.6663C9.14921 12.4377 6.89147 11.3333 5.22527 9.64288C3.68829 8.06668 2.65501 5.99348 2.36914 3.80506C2.34833 3.63769 2.29653 3.45889 2.36991 3.29687C2.44835 3.09237 2.66339 2.95197 2.88147 2.9596C3.43162 2.95858 3.98152 2.96036 4.53168 2.95858C4.74443 2.96469 4.95565 3.09924 5.02928 3.30323C5.08031 3.44795 5.08894 3.6031 5.11712 3.75292C5.17449 4.08535 5.25878 4.41244 5.36084 4.73369C5.40425 4.86544 5.45401 4.99541 5.49057 5.1292C5.54135 5.31462 5.47509 5.52191 5.33672 5.6529C5.11356 5.87826 4.88761 6.10081 4.66547 6.32718C4.5068 6.4859 4.46465 6.74457 4.56265 6.94602C5.15368 7.98783 5.94375 8.91773 6.88512 9.65789C7.07198 9.8138 7.2766 9.94607 7.47234 10.0903C7.64067 10.2035 7.81762 10.3032 7.98899 10.4118C8.14131 10.513 8.34441 10.5351 8.51223 10.4614C8.62038 10.4169 8.70137 10.3296 8.78185 10.2482C8.97682 10.0537 9.168 9.85552 9.36399 9.66196C9.47036 9.56251 9.61482 9.49867 9.76182 9.50782C9.87961 9.50833 9.98777 9.56022 10.0982 9.59379C10.5402 9.74844 10.9967 9.86391 11.4605 9.92928C11.5803 9.95014 11.707 9.96921 11.8071 10.044C11.9594 10.1473 12.0462 10.3322 12.0399 10.5148C12.0366 11.0812 12.0457 11.6482 12.0353 12.2144Z" fill="#686868" />
    <path d="M11.8565 6.39419C11.8802 6.29836 11.8811 6.1981 11.8595 6.10197C11.7096 5.36522 11.3388 4.67372 10.7997 4.14873C10.2678 3.62168 9.57318 3.2641 8.8369 3.12982C8.67161 3.10971 8.49626 3.15259 8.36586 3.25788C8.20471 3.38329 8.11127 3.59062 8.12664 3.7944C8.13965 4.02126 8.28573 4.23598 8.49449 4.32649C8.63553 4.38801 8.79166 4.39866 8.93537 4.45219C9.76035 4.71365 10.423 5.43354 10.6049 6.28121C10.6368 6.44447 10.7004 6.6101 10.8314 6.71953C11.0037 6.87097 11.2622 6.91888 11.4754 6.83163C11.6643 6.76005 11.811 6.59058 11.8565 6.39419Z" fill="#686868" />
  </svg>
);
